<template>
  <div v-if="compListingFiles.images.length || compListingFiles.dataFiles.length">
    <UtilImage
      v-for="file in compListingFiles.images"
      :key="file.fileRef"
      @click="openDataImage(file.fileRef)"
      :fileRef="file.fileRef"
      :width="700"
      canFullScreen
      class="cursor-zoom"
    />

    <div v-if="compListingFiles.dataFiles.length" class="flex flex-wrap">
      <UtilFile
        v-for="file in compListingFiles.dataFiles"
        :key="file.fileRef"
        :fileRef="file.fileRef"
        :extension="file.extension"
        :size="file.size"
        :name="file.originalFileName"
        @clickFile="$openWindow($event, true)"
        class="mt-4 mr-2 cursor-pointer w-6/12 md:w-3/12"
      />
    </div>
  </div>
</template>

<script>
import { fileExtensions } from '@/lib/file-types'
import UtilFile from '@/components/utils/UtilFile'
import UtilImage from '@/components/utils/UtilImage'

export default {
  name: 'ListingFiles',
  components: {
    UtilFile,
    UtilImage
  },
  props: {
    listing: {
      type: Object,
      required: true
    }
  },
  computed: {
    compListingFiles() {
      let files = {
        images: [],
        dataFiles: []
      }

      if (this.listing && this.listing.files) {
        this.listing.files.forEach(file => {
          let key = fileExtensions.image.includes(file.extension) ? 'images' : 'dataFiles'

          files[key].push(file)
        })
      }

      return files
    }
  },
  methods: {
    openDataImage(imageFileRef) {
      this.$analytics.addEvent({
        category: 'listing',
        action: 'Clicked data image'
      })

      this.$store.commit('listing/changeOpenGalleryFileRef', imageFileRef)
    }
  }
}
</script>
